// @vendor
const get = require('lodash/object/get');
const trim = require('lodash/string/trim');

// @api
const { APIPost } = require('utilities/APIRequestHelper');

// @constants
const actionTypes = require('constants/actionTypes');
const {
    SPAIN_COUNTRY_CODE,
} = require('constants/index');

// @ utilities
const { scrollToTop } = require('commonsUtilities/scrollUtils');

// @ actions
const hireContactDataActions = require('actions/hireContactData');
const openYoungTaxDataActions = require('actions/openYoungTaxData');
const signaturePatternActions = require('actions/signaturePattern');

const getOpenYoungProfileDetailsInProgress = () => ({
    type: actionTypes.OPEN_YOUNG_GET_PROFILE_DETAILS_REQUEST
});

const getOpenYoungProfileDetailsSuccess = (response, userInfo, originCountry) => ({
    type: actionTypes.OPEN_YOUNG_GET_PROFILE_DETAILS_SUCCESS,
    payload: {
        response,
        userInfo,
        originCountry
    }
});

const getOpenYoungProfileDetailsFailure = error => ({
    type: actionTypes.OPEN_YOUNG_GET_PROFILE_DETAILS_FAILURE,
    payload: { error }
});


const updateProfileDetailsInProgress = () => ({
    type: actionTypes.OPEN_YOUNG_UPDATE_PROFILE_DETAILS_REQUEST
});

const updateProfileDetailsSuccess = response => ({
    type: actionTypes.OPEN_YOUNG_UPDATE_PROFILE_DETAILS_SUCCESS,
    payload: response
});

const updateProfileDetailsFailure = (error, typeErrors, type) => ({
    type: actionTypes.OPEN_YOUNG_UPDATE_PROFILE_DETAILS_FAILURE,
    payload: { error, typeErrors, type }
});

const resetWizard = () => ({
    type: actionTypes.OPEN_YOUNG_GET_PROFILE_DETAILS_RESET,
});

const reset = () => (dispatch) => {
    dispatch(hireContactDataActions.reset());
    dispatch(openYoungTaxDataActions.reset());
    dispatch(resetWizard());
};

const setVisibleStep = (step) => ({
    type: actionTypes.OPEN_YOUNG_GET_PROFILE_DETAILS_SET_VALIDATE_STEP,
    payload: {
        step,
    }
});

const validate = (step, isValid, dataChanged) => ({
    type: actionTypes.OPEN_YOUNG_GET_PROFILE_DETAILS_VALIDATE_STEP,
    payload: {
        dataChanged,
        step,
        valid: isValid
    }
});

const getStep = (step) => (dispatch, getState) => {
    const valid = getState().openYoungProfileDetails.getIn(['steps', step - 1, 'valid']);
    if (!valid) {
        scrollToTop();
    }
    return valid;
};

const checkIfAddressIsModified = (immHireContactData, immOpenYoungProfileDetails) => {
    return (
        immHireContactData.getIn(['country', 'value']) !== immOpenYoungProfileDetails.get('country') ||
        immHireContactData.getIn(['number', 'value']) !== immOpenYoungProfileDetails.get('numberStreet') ||
        immHireContactData.getIn(['others', 'value']) !== immOpenYoungProfileDetails.get('restOfAddress') ||
        immHireContactData.getIn(['population', 'value']) !== immOpenYoungProfileDetails.get('population') ||
        immHireContactData.getIn(['postalCode', 'value']) !== immOpenYoungProfileDetails.get('postalCode') ||
        immHireContactData.getIn(['province', 'value']) !== immOpenYoungProfileDetails.get('province') ||
        immHireContactData.getIn(['roadName', 'value']) !== immOpenYoungProfileDetails.get('streetName') ||
        immHireContactData.getIn(['roadType', 'value']) !== immOpenYoungProfileDetails.get('typeOfRoads')
    );
};

const validateContactDataStep = (step) => (dispatch, getState) => {
    if (step === 1) {
        dispatch(hireContactDataActions.validateStep());
        const immHireContactData = getState().hireContactData;
        const immOpenYoungProfileDetails = getState().openYoungProfileDetails
        dispatch(validate(step, immHireContactData.get('isValid'), {
            contactData: {
                addressWasUpdated: checkIfAddressIsModified(immHireContactData, immOpenYoungProfileDetails),
                mobileWasUpdated: immHireContactData.getIn(['mobile', 'value']) !== immOpenYoungProfileDetails.get('mobile')
            }
        }));
    } else {
        dispatch(validate(step));
    }
    return dispatch(getStep(step));
};

const validateFiscalDataStep = (step) => (dispatch, getState) => {
    if (step === 1) {
        dispatch(openYoungTaxDataActions.validateStep());
        const immOpenYoungTaxData = getState().openYoungTaxData;
        dispatch(validate(step, immOpenYoungTaxData.get('isValid')));
    } else {
        dispatch(validate(step));
    }
    return dispatch(getStep(step));
};

const setWillCancel = (willCancel) => ({
    type: actionTypes.OPEN_YOUNG_GET_PROFILE_DETAILS_WILL_CANCEL,
    payload: {
        willCancel,
    }
});

const getOpenYoungProfileDetails = (profileIndex) => (dispatch, getState) => {
    const immOpenYoungProfiles = getState().openYoungProfiles;
    const originCountry = getState().profile.get('originCountry');
    const immOpenYoungProfileDetails = immOpenYoungProfiles.getIn(['byId', profileIndex]);
    const requestData = {
        header: {
            version: 1
        },
        query: {
            numeroContrato: immOpenYoungProfileDetails.get('contractNumber'),
            personaMenor: {
              codigodepersona: immOpenYoungProfileDetails.get('personCode'),
              tipodepersona: immOpenYoungProfileDetails.get('personType')
            },
            producto: immOpenYoungProfileDetails.get('product')
        }
    };

    if (immOpenYoungProfileDetails.get('panNumber') !== '') {
        requestData.query.pan = immOpenYoungProfileDetails.get('panNumber');
    }

    dispatch(getOpenYoungProfileDetailsInProgress());

    return APIPost({
        dispatch,
        endpoint: 'openYoungGetProfileDetails',
        params: requestData,
    })
    .then(response => {
        dispatch(getOpenYoungProfileDetailsSuccess(response, immOpenYoungProfileDetails, originCountry));
        return response;
    })
    .catch(response => {
        if (!!response.error) {
            dispatch(getOpenYoungProfileDetailsFailure(response));
        } else {
            throw response;
        }
    });
};

const updateProfileDetailsData = (type) => (dispatch, getState) => {
    let isTypeFiscalData;
    let isAddressModified;
    let isMobileModified;
    const callback = (dispatch, getState, tokenfirma) => {
        const immOpenYoungTaxData = getState().openYoungTaxData;
        const immOpenYoungProfileDetails = getState().openYoungProfileDetails;
        const immHireContactData = getState().hireContactData;
        const mobile = immHireContactData.getIn(['mobile', 'value']).replace(/\-/g, '').replace(/ /g,'');
        const mobileDispositive = immOpenYoungProfileDetails.get('mobileDispositive');

        isTypeFiscalData = type === 'fiscalData';
        isAddressModified = false;
        isMobileModified = false;

        if (type === 'contactData') {
            isAddressModified = immOpenYoungProfileDetails.getIn(['steps', 0, 'addressWasUpdated']);
            isMobileModified = immOpenYoungProfileDetails.getIn(['steps', 0, 'mobileWasUpdated']);
        }

        const requestData = {
            header: {
                version: 1
            },
            query: {
                cliente: {
                    codigodepersona: immOpenYoungProfileDetails.get('personCode'),
                    tipodepersona: immOpenYoungProfileDetails.get('personType'),
                },
                contrato: {
                    numerodecontrato: immOpenYoungProfileDetails.get('contractNumber'),
                    producto: immOpenYoungProfileDetails.get('product'),
                },
                indModifDisp: isMobileModified ? "S" : "N",
                indModifDomicilio: isAddressModified ? "S" : "N",
                indModifPaisTributacion: isTypeFiscalData ? "S" : "N",
                informacionFiscal: {
                    paisNacimiento: immOpenYoungProfileDetails.get('country'),
                    poblacionNacimiento: immOpenYoungProfileDetails.get('populationBirth'),
                    provinciaNacimiento: {
                        discriminante: immOpenYoungProfileDetails.getIn(['provinceBirth', 'discriminatePopulation']),
                        plaza: immOpenYoungProfileDetails.getIn(['provinceBirth', 'population']),
                        provincia: trim(immOpenYoungProfileDetails.getIn(['provinceBirth', 'province'])) || immOpenYoungProfileDetails.get('province')
                    }
                },
                tokenfirma,
            }
        };

        if (immOpenYoungProfileDetails.get('panNumber') !== '') {
            requestData.query.pan = immOpenYoungProfileDetails.get('panNumber');
        }

        if (isMobileModified) {
            requestData.query.dispositivos = [{
                detalleContacto: `${SPAIN_COUNTRY_CODE}-${mobile.substr(0, 3)}-${mobile.substr(3)}`,
                horaDesde: mobileDispositive.get('timeFrom'),
                horaHasta: mobileDispositive.get('timeTo'),
                indPreferente: mobileDispositive.get('indexPreferent'),
                numDispositivo: mobileDispositive.get('numberDispositive'),
                tipoDispositivo: mobileDispositive.get('typeDispositive'),
                tipoUso: mobileDispositive.get('typeUsed'),
            }];
        }

        if (isAddressModified) {
            requestData.query.domicilioHabitual = {
                codFormatoDomicilio: immOpenYoungProfileDetails.get('formatAddress'),
                nombreVia: immHireContactData.getIn(['roadName', 'value']),
                numeroDomicilio: immOpenYoungProfileDetails.get('addressNumber'),
                numeroVia: immHireContactData.getIn(['number', 'value']),
                codigoPostal: immHireContactData.getIn(['postalCode', 'value']),
                pais: immHireContactData.getIn(['country', 'value']),
                poblacion: immHireContactData.getIn(['population', 'value']),
                provincia: {
                    provincia: immHireContactData.getIn(['province', 'value'])
                },
                restoDomicilio: immHireContactData.getIn(['others', 'value']),
                tipoVia: immHireContactData.getIn(['roadType', 'value'])
            };
        }

        if (isTypeFiscalData) {
            let immListCountriesAdditionalTaxing = immOpenYoungTaxData.get('byId');
            let countriesTributation = null;
            if (immListCountriesAdditionalTaxing.size) {
                countriesTributation = [];
                immListCountriesAdditionalTaxing.forEach(immCountry => {
                    countriesTributation.push({
                        docuPersona: {
                            codigodocumpersonacorp: immCountry.getIn(['tin', 'value']),
                            tipodocumpersonacorp: 'TIN'
                        },
                        indTipoTributacion: immCountry.getIn(['reason', 'value']).padEnd(40),
                        paisTributacion: immCountry.getIn(['country', 'value'])
                    });
                });
            }

            requestData.query.tributacionesAdicionales = countriesTributation;
        }

        dispatch(updateProfileDetailsInProgress());

        let errors = {
            address: false,
            mobile: false
        };

        return APIPost({
            dispatch,
            endpoint: 'openYoungUpdateProfileDetails',
            params: requestData,
        })
        .then(response => {
            let success = false;

            if (isTypeFiscalData) {
                if (trim(get(response, 'mensajesTributFis[0].mensaje') || '') === 'ALTA EFECTUADA CORRECTAMENTE') {
                    success = true;
                }
            } else {
                let addressSuccess = true;
                let phoneSuccess = true;

                if (isAddressModified && trim(get(response, 'mensajesDomicilio[0].mensaje') || '') !== 'MODIFICACIÓN EFECTUADA') {
                    addressSuccess = false;
                    errors.address = true;
                }

                if (isMobileModified && trim(get(response, 'mensajesDispositivo[0].mensaje') || '') !== 'MODIFICACION REALIZADA') {
                    phoneSuccess = false;
                    errors.mobile = true;
                }

                success = addressSuccess && phoneSuccess;
            }

            if (success) {
                const newResponse = Object.assign({}, response, { type });
                dispatch(updateProfileDetailsSuccess(newResponse));
            } else {
                dispatch(updateProfileDetailsFailure(response, errors, type));
            }
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(updateProfileDetailsFailure(response, errors, type));
            } else {
                throw response;
            }
        });
    };

    new Promise(() => {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    });
};

module.exports = {
    getOpenYoungProfileDetails,
    reset,
    setVisibleStep,
    setWillCancel,
    updateProfileDetailsData,
    validateContactDataStep,
    validateFiscalDataStep,
};
